import axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';

const state = {
  permissions: {
    isBusy: false,
    data: null,
    error: null
  },
};

const getters = {
  // ACL permissions
  canManageAcl: (state) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === "acl" && d[1] === "manage") !== -1) : false,
  canViewAcl:   (state) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === "acl" && d[1] === "view") !== -1) : false,
  // Projects permissions
  canCreateCommercialProjects: (state) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === "projects" && d[1] === "create_commercial") !== -1) : false,
  canCreateMarketingProjects:  (state) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === "projects" && d[1] === "create_marketing") !== -1) : false,
  // Users permissions
  canManageUsers: (state) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === "users" && d[1] === "manage") !== -1) : false,
  canViewUsers:   (state) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === "users" && d[1] === "view") !== -1) : false,
  canManageClientDashboardStories: (state) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === "carma_ai" && d[1] === "manage_client_dashboard_stories") !== -1) : false,

  // GEO dashboard permission (requires both carma_ai/manage AND carma_ai/manage_geo_dashboard)
  canManageGeoDashboard: (state) => state.permissions.data
    ? (state.permissions.data.findIndex(d => d[0] === "carma_ai" && d[1] === "manage") !== -1
       && state.permissions.data.findIndex(d => d[0] === "carma_ai" && d[1] === "manage_geo_dashboard") !== -1)
    : false,

  hasAclPermission: (state) => (group, action) => state.permissions.data ? (state.permissions.data.findIndex(d => d[0] === group && d[1] === action) !== -1) : false,
};

const mutations = {
  LOAD_PERMISSIONS_BUSY: (state, payload) => {
    state.permissions.isBusy = payload;
  },
  LOAD_PERMISSIONS_SUCCESS: (state, payload) => {
    const data = [];

    // We flatten the permissions
    for (let i = 0, l = payload.length; i < l; ++i) {
      for (let j = 0, k = payload[i].actions.length; j < k; ++j) {
        data.push([payload[i].name, payload[i].actions[j].name]);
      }
    }

    state.permissions.data = data;
    state.permissions.error = null;
  },
  LOAD_PERMISSIONS_FAIL: (state, payload) => {
    state.permissions.data = null;
    state.permissions.error = payload;
  }
};

const actions = {
  getGroups: () => {
    return axios.get('/acl/groups').then(r => {
      return r.data.data;
    });
  },
  getTeams: () => {
    return axios.get('/acl/teams').then(r => {
      return r.data.data;
    });
  },
  deleteTeam: ({ commit }, data) => {
    return axios.delete('/acl/teams/' + data.teamId).then(r => {
      return r.data.data;
    });
  },
  getActions: () => {
    return axios.get('/acl/actions').then(r => {
      return r.data.data;
    });
  },

  getPermissions: ({ commit }) => {
    commit('LOAD_PERMISSIONS_BUSY', true);

    return axios.get('/acl/permissions').then(response => {
        commit('LOAD_PERMISSIONS_SUCCESS', response.data.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_PERMISSIONS_FAIL', error)
      })
      .finally(() => commit('LOAD_PERMISSIONS_BUSY', false));
  },

  getTeamPermissions: ({ commit }, data) => {
    return axios.get('/acl/permissions/' + data.teamId).then(r => {
      return r.data.data;
    });
  },

  getAllTeamPermissions: () => {
    return axios.get('/acl/team-permissions').then(r => {
      return r.data.data;
    });
  },

  createTeam: ({ commit }, data) => {
    return axios.post('/acl/teams/', {
      permissions: data.actions,
      team: data.team
    }).then(r => {
      return r.data.data;
    });
  },

  updateTeamPermissions: ({ commit }, data) => {
    return axios.put('/acl/permissions/' + data.team_id, {
      permissions: data.permissions, 
      team: data.team // to rename the team
    }).then(r => {
      return r.data.data;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};